import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApiErrorNotifications } from "@/components/ApiErrorNotifications";
import { AppRuntimeEffects } from "@/components/AppRuntimeEffects";
import { SuccessNotifications } from "@/components/SuccessNotifications";
import { AccountLayout } from "@/components/Layout/account/AccountLayout";
import { Footer } from "@/components/Layout/Footer";
import { Header } from "@/components/Layout/Header";
import { AppRuntimeBoundary } from "@/components/AppRuntimeBoundary";
import { MAIN_CONTENT_HREF, MAIN_CONTENT_ID } from "@/constants/a11y";
import { isAccountRoutePath } from "@/constants/navigation";
import { useAuth } from "@/contexts/AuthContext";
import { AppRouteSwitch } from "@/routes/AppRouteSwitch";
import { useRouteDocumentMetadata } from "@/routes/useRouteDocumentMetadata";

export function App() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const { runtimeResetKey } = useRouteDocumentMetadata();
  const useAccountLayout = isAccountRoutePath(pathname) && isAuthenticated;
  const mainContent = (
    <main
      id={MAIN_CONTENT_ID}
      className={`app-main ${useAccountLayout ? "account-layout__main" : ""}`}
      tabIndex={-1}
    >
      <AppRuntimeBoundary resetKey={runtimeResetKey}>
        <AppRouteSwitch />
      </AppRuntimeBoundary>
    </main>
  );

  return (
    <div className="app-shell">
      <AppRuntimeEffects />
      <a className="skip-link" href={MAIN_CONTENT_HREF}>
        {t("a11y.skipToContent")}
      </a>
      {useAccountLayout ? (
        <AccountLayout>{mainContent}</AccountLayout>
      ) : (
        <>
          <Header />
          {mainContent}
          <Footer />
        </>
      )}
      <ApiErrorNotifications />
      <SuccessNotifications />
    </div>
  );
}
